<template>
    <div class="">
        <div class="flex items-end space-x-1.5">
            <div class="text-2xl md:text-4xl font-bold">
                {{ item.stat.toLocaleString() }}
            </div>
            <!-- <div class="text-green-500 text-sm mb-0.5 font-medium">
                <span v-if="item.changeType === 'increase'">↗</span>
                <span v-else>↘</span>
                 {{ item.change }}
            </div> -->
        </div>
        <div class="text-xs md:text-sm font-medium text-gray-700">
            {{ item.name }}
        </div>
    </div>

    <!-- <div class="px-4 py-5 sm:p-6">
        <dt class="text-base font-normal text-gray-900">
            {{ item.name }}
        </dt>
        <dd class="mt-1 flex justify-between items-baseline md:block lg:flex">
            <div class="flex items-baseline text-2xl font-semibold text-regal-blue-700">
                {{ item.stat.toLocaleString() }}
                <span class="ml-2 text-sm font-medium text-gray-500"> from {{ item.previousStat.toLocaleString() }} </span>
            </div>

            <div :class="[item.changeType === 'increase' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800', 'inline-flex items-baseline px-2.5 py-0.5 rounded-full text-sm font-medium md:mt-2 lg:mt-0']">
                <ArrowSmUpIcon v-if="item.changeType === 'increase'" class="-ml-1 mr-0.5 shrink-0 self-center h-5 w-5 text-green-500" aria-hidden="true" />
                <ArrowSmDownIcon v-else class="-ml-1 mr-0.5 shrink-0 self-center h-5 w-5 text-red-500" aria-hidden="true" />
                <span class="sr-only"> {{ item.changeType === 'increase' ? 'Increased' : 'Decreased' }} by </span>
                {{ item.change }}
            </div>
        </dd>
    </div> -->
</template>

<script>
import { ArrowSmDownIcon, ArrowSmUpIcon } from '@heroicons/vue/solid'

export default {
    components: {
        ArrowSmDownIcon,
        ArrowSmUpIcon,
    },
    props: {
        item: Object
    }
}
</script>
